<template>
  <div v-if='!arrayLog || arrayLog.length == 0'>
    <h2 class="message" @click="$emit('reload')" style="cursor: pointer;">
      <refresh-cw-icon v-if="loading"></refresh-cw-icon>
      <book-open-icon v-else></book-open-icon>
      <p>{{ loading ? $t('files.loading') : (!arrayLog ? $t('info.clickToLoad') : $t('info.logsLonely')) }}</p>
    </h2>
  </div>
  
  <div v-else id="listing" class="list">
    <div v-if="arrayLog && arrayLog.length > 0" class="invoicelist" ref="list">
      <item v-for="(item, i) in arrayLog"
        :key="i"
        v-bind:item="item">
      </item>
    </div>
  </div>
</template>
  
<script>
  import Item from './ListingLogsItem.vue';
  import { BookOpenIcon, RefreshCwIcon } from 'vue-feather-icons';
  
  export default {
    name: 'listing',
    props: ['reloadTime'],
    components: { Item, BookOpenIcon, RefreshCwIcon },
    data: function () {
      return {
        arrayLog: null,
        loading: false,
        currentPage: 1,
        currentNodes: new Map(),
      };
    },
    watch: {
      reloadTime(val) {
        if (val !== null) {
          this.reload();
        }
      },
      arrayLog(val) {
        if (val && val.length) {
          this.$nextTick(() => {
            this.$refs.list.addEventListener('scroll', this.scrollEvent);
          });
        } else if (this.$refs.list) {
          this.$refs.list.removeEventListener('scroll', this.scrollEvent);
        }
      }
    },
    beforeDestroy () {
      this.$refs.list && this.$refs.list.removeEventListener('scroll', this.scrollEvent);
      this.currentNodes.clear();
    },
    methods: {
      async processLog(log) {
        const mergedLog = [...this.arrayLog, ...log];
        for (let i = this.arrayLog.length; i < mergedLog.length; i++) {
          const logItem = mergedLog[i];
          if (!logItem.node) {
            for (let j = i-1; j >= 0; j--) {
              const logItem2 = mergedLog[j];
              if (logItem.handle === logItem2.handle && logItem2.node) {
                logItem.node = logItem2.node;
                break;
              }
            }
            // Node not found in other log items
            if (!logItem.node) {
              let node;
              if (this.currentNodes.has(logItem.handle)) {
                node = this.currentNodes.get(logItem.handle);
              } else {
                const action = await ibb.getNodeById(logItem.handle);
                node = action.node;
                this.currentNodes.set(logItem.handle, node);
              }
              logItem.currentNode = node;
            }
          } 
        }
      },
      async reload() {
        this.loading = true;
        this.arrayLog = [];
        this.currentPage = 1;
        const action = await ibb.getAccountLog(this.currentPage);
        await this.processLog(action.log);
        this.arrayLog = action.log;
        this.loading = false;
      },
      async loadNextPage() {
        if (this.currentPage == null) return;
        const action = await ibb.getAccountLog(++this.currentPage);
        if (action.log.length == 0) {
          this.currentPage = null;
          return;
        }
        this.processLog(action.log);
        this.arrayLog.push(...action.log);
      },
      scrollEvent () {
        if (this.$refs.list.scrollTop >= (this.$refs.list.scrollHeight - this.$refs.list.clientHeight)) {
          this.loadNextPage();
        }
      }
    }
  };
  </script>